import React from 'react';
import View from "../components/three/Scene3D/View"

function Iphone() {

    return (
        <React.Fragment> 
                <View />
        </React.Fragment>
    );


}
export default Iphone;